const INIT_PAGINATION: string = 'pagination/INIT_PAGINATION';
const SET_CURRENTPAGE: string = 'pagination/SET_CURRENTPAGE';
const SET_MAXPAGE    : string = 'pagination/SET_MAXPAGE';
const SET_VIEWCOUNT  : string = 'pagination/SET_VIEWCOUNT';

type initPaginationAction = {
    type: typeof INIT_PAGINATION;
    payload: number;
};
type setCurrentPageAction = {
    type: typeof SET_CURRENTPAGE;
    payload: number;
}
type setMaxPageAction = {
    type: typeof SET_MAXPAGE;
    payload: number;
}
type setViewCountAction = {
    type: typeof SET_VIEWCOUNT;
    payload: number;
}

type ActionType =
    initPaginationAction |
    setCurrentPageAction |
    setMaxPageAction     |
    setViewCountAction;

export const initPagination = (init: number) => ({type : INIT_PAGINATION});
export const setCurrentPage = (current: number) => ({type : SET_CURRENTPAGE, payload: current});
export const setMaxPage     = (maxPage: number) => ({type : SET_MAXPAGE    , payload: maxPage});
export const setViewCount = (viewCount: number) => ({type : SET_VIEWCOUNT, payload: viewCount});

interface InitialStateType {
    viewCount: number;
    loaded: boolean;
    current: number;
    maxPage: number;
};

const initialState: InitialStateType = {
    viewCount: 10,
    loaded: true,
    current: 1,
    maxPage: 1,
};

export default function pagination(state: InitialStateType = initialState, action: ActionType) {
    switch(action.type) {
        case INIT_PAGINATION:
            return initialState;
        case SET_CURRENTPAGE:
            return {
                ...state,
                current: action.payload,
            };
        case SET_MAXPAGE:
            return {
                ...state,
                maxPage: action.payload,
            }
        case SET_VIEWCOUNT:
            return {
                ...state,
                viewCount: action.payload,
            }
        default:
            return state;
    }
}